import React, { useEffect, useState } from 'react';
import axios from 'axios';
// icons
import { BsArrowUpRight } from 'react-icons/bs';
// motion
import { motion } from 'framer-motion';
// variants
import { fadeIn } from '../variants';
import { Link } from 'react-router-dom';

import APIEndPoints from '../middleware/APIEndPoints';

const Services = () => {
  // State to store services fetched from the API
  const [services, setServices] = useState([]);
  
  // Fetch services data when the component mounts
  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await axios.get(APIEndPoints.services.url); 
        setServices(response.data);
      } catch (error) {
        console.error('Error fetching services:', error);
      }
    };
    
    fetchServices();
  }, []); // Empty dependency array ensures this effect runs only once on mount

  return (
    <section className='section pt-10' id='services'>
      <div className='container mx-auto'>
        <div className='flex flex-col lg:flex-row'>
          {/* Text & Image */}
          <motion.div
            variants={fadeIn('right', 0.3)}
            initial="hidden"
            whileInView="show"
            viewport={{ once: false, amount: 0.3 }}
            className='flex-1 bg-services lg:bg-bottom  bg-no-repeat mix-blend-lighten mb-12 lg:mb-0 '
          >
            <h2 className='h2 text-accent mb-6 text-2xl lg:text-4xl'>My Services</h2>
            <h3 className='h3 max-w-[455px] mb-16 text-xl lg:text-3xl'>
              Crafting elegant and responsive web interfaces with a passion for turning ideas into seamless digital experiences.
            </h3>
            <Link to='/my-skills'>
              <button className='btn btn-sm'>View my skills</button>
            </Link>
          </motion.div>
          
          {/* Services */}
          <motion.div
            variants={fadeIn('left', 0.5)}
            initial="hidden"
            whileInView="show"
            viewport={{ once: false, amount: 0.3 }}
            className="flex-1 px-2 max-h-[600px] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-600 scrollbar-track-transparent hover:scrollbar-thumb-pink-500"
          >
            {/* Service list */}
            <div className='scrollbar-thin hover:scrollbar-thumb-pink-500 scrollbar-thumb-transparent'>
              {services.length > 0 ? (
                services.map((service, index) => {
                  const { name, description, link } = service;
                  return (
                    <div className='border-b border-white/20 h-[146px] mb-[38px] flex justify-around items-center' key={index}>
                      <div className='max-w-[466px]'>
                        <h4 className='text-[20px] tracking-wider font-primary font-semibold mb-6'>{name}</h4>
                        <div className='font-secondary leading-tight p-2'>{description}</div>
                      </div>
                      <div className='flex flex-col flex-1 items-end '>
                        <motion.a
                          whileHover={{ scale: 1.2 }}
                          className='btn w-9 h-9 mb-[42px] flex justify-center items-center'
                        >
                          <motion.div
                            whileHover={{ rotate: 40 }}
                            transition={{ duration: 0.3 }}
                          >
                            <BsArrowUpRight />
                          </motion.div>
                        </motion.a>
                        <a href={link} className='text-gradient text-sm'>
                          learn more
                        </a>
                      </div>
                    </div>
                  );
                })
              ) : (
                <p>Loading services...</p>
              )}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Services;
